import { ObjectValues } from 'helpers/types';

export const UNITS = {
  DOLLAR: 'dollar',
  PERCENTAGE: 'percentage',
} as const;

export type UnitTypes = ObjectValues<typeof UNITS>;

export const UNIT_TO_VALUE_TYPE_MAP: Record<UnitTypes, string> = {
  [UNITS.DOLLAR]: '$',
  [UNITS.PERCENTAGE]: '%',
};
